import { createRoute, useParams } from "@tanstack/react-router";
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/reset-password/$token",
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = useParams({ from: "/reset-password/$token" });
  return <ResetPasswordForm token={token} />;
}
